export const userTypes = {
  DEVICE: 'DEVICE',
  USER: 'USER',
};
